import styled, { css, keyframes } from 'styled-components';
import COLORS from 'constants/colors';
import { Col, FlexView, Text } from '@cuemath/comps';

export const Wrapper = styled(FlexView)`
  height: inherit;
  flex-wrap: no-wrap;
`;

export const IconCol = styled(FlexView)`
  ${({ marginTop }) =>
    marginTop &&
    css`
      margin-top: ${() => (marginTop ? 14 : 0)}px;
    `};
  width: 68px;
  height: 44px;
  cursor: pointer;
  justify-content: center;
`;

export const slide = (top, prevTop) => keyframes`
  0% {
    top: ${prevTop}px;
  }
  60% {
    top: ${top}px;
  }
`;

export const WhiteBar = styled.div`
  position: absolute;
  background: ${COLORS.WHITE};
  width: 4px;
  height: 44px;
  left: 0;
  top: ${({ top }) => top}px;
  animation-name: ${({ top, prevTop }) => slide(top, prevTop)};
  animation-duration: 0.2s;
  animation-timing-function: ease-out;
`;

export const Overlay = styled.div`
  position: absolute;
  background: rgba(255, 255, 255, 0.1);
  width: ${({ width }) => width}px;
  height: 40px;
  left: 16px;
  border-radius: 8px;
`;

export const LeadsContainer = styled.div`
  position: relative;
  height: 24px;
`;

export const IconWrapper = styled.div`
  position: relative;
`;

export const StyledCol = styled(Col)`
  .popup-overlay {
    z-index: 2;
  }
`;

export const StyledText = styled(Text)`
  white-space: pre-wrap;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 18px;
`;

export const Logo = styled.img`
  display: block;
  width: 24px;
  height: 24px;
`;
